import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class GeneralService {
    private token!: string;
    private httpOptions: any;

    private basePath = environment.interop.basePath;

    private listUrl = this.basePath + environment.interop.indoc.nomenclatoare.registratura.general.list;

    private updateUrl = this.basePath + environment.interop.indoc.nomenclatoare.registratura.general.update;

    private updateMultipleUrl = this.basePath + environment.interop.indoc.nomenclatoare.registratura.general.updateMultiple;

    private clearCacheUrl = this.basePath + environment.interop.indoc.nomenclatoare.registratura.general.clearCache;

    constructor(private http: HttpClient) { }

    list() {
        return this.http.get(this.listUrl, this.httpOptions);
    }

    update(payload: any) {
        return this.http.put(this.updateUrl, payload, this.httpOptions);
    }

    updateMultiple(payload: any) {
        return this.http.put(this.updateMultipleUrl, payload, this.httpOptions);
    }

    clearCache() {
        return this.http.get(this.clearCacheUrl, this.httpOptions);
    }

    setToken(token: string) {
        this.token = token;
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: `Bearer ${this.token}`,
            }),
        };
    }
}
